import React from 'react'
import { JsonLd } from 'src/views/components'
import { headerLogoSchema } from 'src/models/Schema'
import logo from 'src/images/logo_horizontal.png'
import { mysiteContainer } from 'src/models/Mysite'
import {
  getImageUrl,
  isEquinoxMysite,
  isEquinoxPOSite,
} from 'src/utils/mySiteUtils'
import './styles.scss'

class HeaderLogo extends React.PureComponent {
  componentDidMount() {
    if (isEquinoxMysite() || isEquinoxPOSite()) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    if (isEquinoxMysite() || isEquinoxPOSite()) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    const clssNameFromHeader = document.querySelector('.nu-header-container')
    const logo = document.querySelector('.mysite-logo-image')

    if (logo && clssNameFromHeader) {
      if (clssNameFromHeader.classList.contains('compact-view')) {
        logo.classList.add('scrolled')
      } else if (clssNameFromHeader.classList.contains('full-view')) {
        logo.classList.remove('scrolled')
      }
    }
  }

  render() {
    const {
      requestDomain,
      isNuskinHeader = false,
      headerLogoUrl = '',
      logoTestId = '',
    } = this.props
    const schemaData = headerLogoSchema({ requestDomain })
    const byDefaultPlaceHolder =
      'https://media.nuskin.com/m/5759f4991d36b1fe/original/nu-skin-logo.svg'
    const { user = {} } = mysiteContainer?.mysiteShopHeaderResponse || {}
    const mysiteLogo = user?.siteLogo ? getImageUrl(user?.siteLogo) : ''
    if (
      mysiteLogo &&
      mysiteLogo !== '' &&
      (isEquinoxMysite() || isEquinoxPOSite())
    ) {
      return (
        <img
          className="mysite-logo-image"
          alt="My Site logo,HomePage"
          src={mysiteLogo}
          data-testid="qa-mysite-logo"
        />
      )
    } else if (isNuskinHeader) {
      return (
        <img
          className="nu-logo-image"
          alt="Nu Skin logo,HomePage"
          src={headerLogoUrl || byDefaultPlaceHolder}
          data-testid={
            logoTestId ? `qa-nuskin-logo-${logoTestId}` : 'qa-nuskin-logo'
          }
        />
      )
    } else {
      return (
        <>
          {/* <HeaderLogoView /> */}
          <img
            className="logo-image des-display"
            alt="Nu Skin logo,HomePage"
            src="https://media.nuskin.com/m/2c95048647c42590/Vector_to_PNG-logo.png"
            data-testid={
              logoTestId ? `qa-nuskin-logo-${logoTestId}` : 'qa-nuskin-logo'
            }
          />
          <img
            className="logo-image mob-display-logo"
            alt="Nu Skin logo,HomePage"
            src={logo}
          />
          <JsonLd data={schemaData} key="schema-headerLogo" />
        </>
      )
    }
  }
}

export { HeaderLogo }
export default HeaderLogo
